import React from 'react';
import { getRouteTitle, RoutePath } from '../routes';
import PageTitle from '../../frontend-common-libs/src/components/common/page-title/PageTitle';

type Props = {
  path: RoutePath;
  className: string;
};

export default function CorePageTitle({ path, className }: Props) {
  const routeTitle = getRouteTitle(path);
  return <PageTitle routeTitle={routeTitle} className={className} />;
}
